var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.501,
    viewBox: "0 0 16 13.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tasks-duotone",
    transform: "translate(-0.001 -31.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M201.492,74H192.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h8.992a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,201.492,74Zm0-10H192.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h8.992a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,201.492,64Zm0,5H192.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h8.992a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,201.492,69Z",
    transform: "translate(-185.991 -31.029)",
    fill: "#113483",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M4.36,32.081a.374.374,0,0,0-.531,0L1.841,34.059l-.709-.691a.374.374,0,0,0-.531,0l-.49.491a.375.375,0,0,0,0,.531L1.6,35.872a.4.4,0,0,0,.55,0l.487-.488,2.254-2.256a.378.378,0,0,0,0-.531Zm0,4.975a.374.374,0,0,0-.531,0L1.841,39.047l-.709-.691a.374.374,0,0,0-.531,0l-.49.49a.375.375,0,0,0,0,.531l1.482,1.484a.4.4,0,0,0,.55,0l.49-.49,2.254-2.257a.375.375,0,0,0,0-.528ZM2,42.471a1.5,1.5,0,1,0,0,3,1.5,1.5,0,0,0,0-3Z",
    transform: "translate(0)",
    fill: "#113483"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.b4c2226f.svg";
export { ForwardRef as ReactComponent };